import { FC } from "react";

export const LoaderIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.472 4.39102C12.8653 3.86899 11.1345 3.86901 9.52779 4.39108C7.92107 4.91316 6.52087 5.93047 5.52786 7.29724C4.53485 8.664 4.00001 10.31 4 11.9995C3.99999 13.6889 4.5348 15.3349 5.52779 16.7017C6.52078 18.0685 7.92097 19.0858 9.52768 19.6079C11.1344 20.13 12.8651 20.13 14.4719 19.608C16.0786 19.086 17.4789 18.0688 18.4719 16.7021C19.465 15.3353 19.9999 13.6893 20 11.9999C20 11.4476 20.4478 10.9999 21 11C21.5523 11 22 11.4477 22 12C21.9999 14.1118 21.3313 16.1693 20.0899 17.8777C18.8486 19.5861 17.0983 20.8577 15.0899 21.5102C13.0814 22.1627 10.918 22.1626 8.9096 21.51C6.90121 20.8574 5.15098 19.5857 3.90974 17.8772C2.6685 16.1688 1.99998 14.1112 2 11.9994C2.00002 9.88768 2.66856 7.83012 3.90982 6.12167C5.15109 4.41321 6.90134 3.14157 8.90974 2.48898C10.9181 1.83639 13.0816 1.83636 15.09 2.48889C15.6153 2.65955 15.9027 3.2237 15.7321 3.74895C15.5614 4.27421 14.9973 4.56167 14.472 4.39102Z"
      fill="currentColor"
    />
  </svg>
);
